import { AllSignalsCommon } from './shared/all-signals-common-view';

export const AllSignalsListView = () => {
  return <AllSignalsCommon isListView={true} />;
};
